import { Injectable } from '@angular/core';
import { Http, Headers, URLSearchParams } from '@angular/http';
import { Configuration } from '../../app.constants';
import { AuthenticationService } from './authentication.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class PrintingService {
  _printUrl = this._configuration.apiUrl + '/v2/print';

  constructor(private _http: Http,
    private _configuration: Configuration,
    public _authService: AuthenticationService) { }


  print(printJob: any, printer: number, copies: number, type: string): Observable<any> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('printer', printer + '');
    s.append('copies', copies + '');
    s.append('type', type);

    return this._http.post(this._printUrl, printJob, { headers: h, search: s }).map(response => response.json());
  }

}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/shared/services/printing.service.ts